// @flow
import * as React from 'react';

// Components
import AdvisorAssistance from './AdvisorAssistance/';
import NoAdvisorAssistance from './NoAdvisorAssistance/';

// Constants
import { TRANSPORTATION } from 'constants/transportation';
import { SELF_CHECK_IN_FLOW } from 'constants/selfCheckIn';

const { DROPOFF, WAITER } = TRANSPORTATION;
const {
  NON_OPERATING_HOURS_ADDITIONAL_SERVICE_CHECK_IN,
  NON_OPERATING_HOURS_CHECK_IN
} = SELF_CHECK_IN_FLOW;

export type Props = {
  transportationOption: string,
  selfCheckInFlow: string
};

const SpeakToAdvisorPage = ({
  transportationOption,
  selfCheckInFlow
}: Props) => {
  const isDealerClosedNow =
    selfCheckInFlow === NON_OPERATING_HOURS_ADDITIONAL_SERVICE_CHECK_IN ||
    selfCheckInFlow === NON_OPERATING_HOURS_CHECK_IN;
  const needAdvisorAssistance =
    (transportationOption !== DROPOFF && transportationOption !== WAITER) ||
    isDealerClosedNow;
  return needAdvisorAssistance ? (
    <AdvisorAssistance />
  ) : (
    <NoAdvisorAssistance />
  );
};

export default SpeakToAdvisorPage;



// WEBPACK FOOTER //
// ./src/components/pages/SelfCheckIn/SpeakToAdvisorPage/SpeakToAdvisorPage.js